import { Container, Item } from 'Components/Grid';
import HistoryRowBasicItem from 'Components/HistoryRowBasicItem';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

const fm = (id: string, values?: { [key: string]: string | number | null }): React.JSX.Element => (
  <FormattedMessage id={id} values={values} />
);

const SickLeaveHistoryRowData = ({ d }: IOwnProps): React.JSX.Element => (
  <Container alignItems="flex-start">
    <Item>
      <HistoryRowBasicItem
        header={fm('comorbidity.reasonForSickLeave')}
        value={d.reasonForSickLeave ? fm(`comorbidity.opts.reasonForSickLeave.${d.reasonForSickLeave}`) : '-'}
      />
    </Item>
  </Container>
);

interface IOwnProps {
  d: IDocumentWithTypeV2<'sickLeave'>;
}

export default SickLeaveHistoryRowData;
